// "Accepter handelsbetingelser" gate for the cart drawer and cart page
// (markup in snippets/cart-terms.liquid).
//
// The cart drawer is re-rendered via the Section Rendering API whenever the
// cart changes, which would reset the checkbox — so the accepted state is kept
// in sessionStorage and restored by <cart-terms> when it (re)connects.
//
// Checkout clicks are caught with one delegated capture-phase listener, so it
// keeps working after re-renders. Guarded because the script can be included
// twice on one page (drawer + cart page).
if (!customElements.get('cart-terms')) {
  const STORAGE_KEY = 'cart-terms-accepted';

  const readAccepted = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  };

  const writeAccepted = (accepted) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, String(accepted));
    } catch (error) {
      // Storage unavailable (private mode etc.) — state just won't persist.
    }
  };

  class CartTerms extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.cart-terms__checkbox');
      if (!this.checkbox) return;

      this.checkbox.checked = readAccepted();
      this.onChange = this.onChange.bind(this);
      this.checkbox.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.onChange);
    }

    onChange() {
      writeAccepted(this.checkbox.checked);
      document.querySelectorAll('cart-terms').forEach((terms) => terms.sync());
    }

    sync() {
      this.checkbox.checked = readAccepted();
      if (this.checkbox.checked) {
        this.checkbox.removeAttribute('aria-invalid');
        this.classList.remove('cart-terms--error', 'cart-terms--shake');
      }
    }

    showError() {
      this.checkbox.setAttribute('aria-invalid', 'true');
      this.classList.add('cart-terms--error');
      // Restart the shake animation on every blocked click.
      this.classList.remove('cart-terms--shake');
      void this.offsetWidth;
      this.classList.add('cart-terms--shake');
      this.checkbox.focus({ preventScroll: true });
    }
  }

  customElements.define('cart-terms', CartTerms);

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button[name="checkout"]');
      if (!button) return;

      const scope = button.closest('[data-cart-terms-scope]');
      const terms = scope?.querySelector('cart-terms');
      if (!terms || terms.checkbox?.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      terms.showError();
    },
    true,
  );
}
